<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex >
      Тут менеджер/админ может изменить свои данные: имя, телефон, пароль....
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  /**
   * The name of the page.
   */
  name: 'AccountIndex',

  /**
   * The components that the page can use.
   */
  components: {
  },
};
</script>
